/** @format */

import { makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import SimpleSelectRest from '../../../components/Adescom/SimpleSelectRest';
import CustomInputExtNumber from '../../../components/CustomInput/CustomInputExtNumber';
import InputFormRest from '../../../components/Form/InputFormRest';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import RateInterface from '../../../interfaces/billing/RateInterface';
import i18n from '../../../core/i18n';

interface RateCallProps {
    changeRateInput: (e: any, stateName: string) => void;
    changeRateSelect: (e: any, stateName: string) => void;
    rateEntity: RateInterface;
    rateEntityStatus: any;
}

export const RateCall = (props: RateCallProps): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const { rateEntity, rateEntityStatus, changeRateInput, changeRateSelect } = props;

    const typeCollections = useMemo((): any => {
        return {
            'hydra:member': [
                { name: i18n.t('pricelists:collections.time'), value: 2 },
                { name: i18n.t('pricelists:collections.one_time'), value: 1 },
                { name: i18n.t('pricelists:collections.free'), value: 0 },
            ],
        };
    }, []);

    const countingCollection = useMemo((): any => {
        return {
            'hydra:member': [
                { name: i18n.t('pricelists:collections.one'), value: 1 },
                { name: i18n.t('pricelists:collections.three'), value: 3 },
                { name: i18n.t('pricelists:collections.six'), value: 6 },
            ],
        };
    }, []);

    return (
        <GridContainer>
            <GridItem xs={12}>
                <GridContainer>
                    <GridItem xs={12}>
                        <SimpleSelectRest
                            callback={changeRateSelect}
                            restElements={typeCollections}
                            stateName="type"
                            idState="type"
                            idSelected={rateEntity.type}
                            propKey="value"
                            required={false}
                            propValue="name"
                            emptyLabel="translation:common.empty_label"
                            label="pricelists:h.type"
                        />
                    </GridItem>
                    {rateEntity.type === 2 && (
                        <GridItem xs={12}>
                            <SimpleSelectRest
                                callback={changeRateSelect}
                                restElements={countingCollection}
                                stateName="countingUnit"
                                idState="countingUnit"
                                idSelected={rateEntity.countingUnit}
                                propKey="value"
                                required={false}
                                propValue="name"
                                emptyLabel="translation:common.empty_label"
                                label="pricelists:h.counting_unit"
                            />
                            <GridContainer>
                                <GridItem xs={5}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="interval1"
                                        stateObjectState={rateEntityStatus.interval1}
                                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                        typeField={FormGeneralHelper.TYPE_NUMBER}
                                        step={1}
                                        displayFieldName="pricelists:h.interval1"
                                        required={true}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.interval1}
                                    />
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="price1"
                                        stateObjectState={rateEntityStatus.price1}
                                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                        typeField={FormGeneralHelper.TYPE_NUMBER}
                                        displayFieldName="pricelists:h.price1"
                                        required={true}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.price1}
                                    />
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="duration1"
                                        stateObjectState={rateEntityStatus.duration1}
                                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                        typeField={FormGeneralHelper.TYPE_NUMBER}
                                        step={1}
                                        displayFieldName="pricelists:h.duration1"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.duration1}
                                    />
                                </GridItem>
                                <GridItem xs={2}></GridItem>
                                <GridItem xs={5}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="interval2"
                                        stateObjectState={rateEntityStatus.interval2}
                                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                        typeField={FormGeneralHelper.TYPE_NUMBER}
                                        step={1}
                                        displayFieldName="pricelists:h.interval2"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.interval2}
                                    />
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="price2"
                                        stateObjectState={rateEntityStatus.price2}
                                        typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                        typeField={FormGeneralHelper.TYPE_NUMBER}
                                        displayFieldName="pricelists:h.price2"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.price2}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    {(rateEntity.type === 2 || rateEntity.type === 1) && (
                        <GridItem xs={12}>
                            <InputFormRest
                                classes={classes}
                                callback={changeRateInput}
                                stateName="initial"
                                stateObjectState={rateEntityStatus.initial}
                                typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                typeField={FormGeneralHelper.TYPE_NUMBER}
                                displayFieldName="pricelists:h.initial_price"
                                required={true}
                                vMax={255}
                                vMin={0}
                                value={rateEntity.initial}
                            />
                        </GridItem>
                    )}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
